(function () {
var SPOOD = window.SDU_SPOOD, SCENES = window.SDU_SCENES;
function init(root) {
if (root.dataset.ready) return; root.dataset.ready = '1';
var items = []; try { items = JSON.parse(root.querySelector('[data-sdu-items]').textContent).filter(function (i) { return i.img; }); } catch (e) {}
var byId = {}; items.forEach(function (i) { byId[i.id] = i; });
var stage = root.querySelector('[data-sdu-stage]'), canvas = stage.querySelector('canvas'), layer = stage.querySelector('[data-sdu-layer]');
var hint = stage.querySelector('[data-sdu-hint]'), status = root.querySelector('[data-sdu-status]');
var tools = root.querySelectorAll('[data-sdu-tool]');
var currency = root.dataset.currency || 'USD';
var KEY = 'spood-dressup-v1';
var placed = [], sel = null, scene = root.dataset.scene || 'winter', uid = 0;
var ratio = 5 / 4, photos = {}, spImg = null, cfg = {};
try { cfg = JSON.parse(root.querySelector('[data-sdu-cfg]').textContent); } catch (e) {}
function loadImg(u, cb) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { cb(im); }; im.onerror = function () { var b = new Image(); b.onload = function () { cb(b); }; b.src = u; }; im.src = u; }
Object.keys(cfg.photos || {}).forEach(function (k) { var u = cfg.photos[k]; if (u) loadImg(u, function (im) { photos[k] = im; if (k === scene) drawBg(); }); });
function drawScene(x, W, H) { var im = photos[scene]; stage.classList.toggle('is-photo', !!(cfg.photos && cfg.photos[scene])); if (im) { x.fillStyle = '#fff'; x.fillRect(0, 0, W, H); var k = Math.min(W / im.naturalWidth, H / im.naturalHeight), w = im.naturalWidth * k, h = im.naturalHeight * k; x.drawImage(im, (W - w) / 2, (H - h) / 2, w, h); } else if (cfg.photos && cfg.photos[scene]) { x.fillStyle = '#fff'; x.fillRect(0, 0, W, H); } else (SCENES[scene] || SCENES.winter).draw(x, W, H); }
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function drawBg() { var r = stage.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2); canvas.width = Math.round(r.width * d); canvas.height = Math.round(r.height * d); if (r.width) ratio = r.height / r.width; drawScene(canvas.getContext('2d'), canvas.width, canvas.height); }
function save() { try { localStorage.setItem(KEY, JSON.stringify({ scene: scene, p: placed.map(function (p) { return [p.item.id, +p.x.toFixed(3), +p.y.toFixed(3), +p.w.toFixed(3), p.flip ? 1 : 0]; }) })); } catch (e) {} }
function say(t) { if (status) status.textContent = t; }

function render(p) {
var el = p.el;
el.style.left = p.x * 100 + '%'; el.style.top = p.y * 100 + '%'; el.style.width = p.w * 100 + '%';
el.style.zIndex = 10 + placed.indexOf(p);
el.classList.toggle('is-flip', !!p.flip); el.classList.toggle('is-sel', p === sel);
}
function renderAll() { placed.forEach(render); hint.hidden = placed.length > 0; tools.forEach(function (b) { b.disabled = !sel && b.dataset.sduTool !== 'clear'; }); updateShop(); }

function add(item, x, y, w, flip, quiet) {
var p = { id: ++uid, item: item, x: x == null ? 0.5 : x, y: y == null ? 0.55 : y, w: w || item.size / 100, flip: !!flip, ar: 1 };
var el = document.createElement('button'); el.type = 'button'; el.className = 'sdu-piece'; el.setAttribute('aria-label', item.name + ' (drag to move)');
var img = new Image(); img.alt = ''; img.src = item.img; img.draggable = false;
img.onload = function () { p.ar = img.naturalHeight / img.naturalWidth || 1; if (p.floor) { p.floor = false; p.y = Math.max(0.2, 0.93 - p.w * p.ar / ratio / 2); render(p); save(); } };
if (!quiet && item.kind === 'hide') p.floor = true;
el.appendChild(img); p.el = el; p.img = img; layer.appendChild(el); placed.push(p);
bind(p);
if (!quiet) { sel = p; if (!reduce) { el.classList.add('is-pop'); setTimeout(function () { el.classList.remove('is-pop'); }, 400); } say(item.name + ' added!'); save(); }
renderAll(); return p;
}
function bind(p) {
var el = p.el, start = null;
el.addEventListener('pointerdown', function (e) {
e.preventDefault(); sel = p; renderAll();
var r = stage.getBoundingClientRect();
start = { dx: e.clientX - (r.left + p.x * r.width), dy: e.clientY - (r.top + p.y * r.height) };
el.setPointerCapture(e.pointerId); el.classList.add('is-drag');
});
el.addEventListener('pointermove', function (e) {
if (!start) return; var r = stage.getBoundingClientRect();
p.x = Math.min(1, Math.max(0, (e.clientX - start.dx - r.left) / r.width));
p.y = Math.min(1, Math.max(0.03, (e.clientY - start.dy - r.top) / r.height));
render(p);
});
function end() { if (!start) return; start = null; el.classList.remove('is-drag'); save(); }
el.addEventListener('pointerup', end); el.addEventListener('pointercancel', end);
el.addEventListener('focus', function () { if (sel !== p) { sel = p; renderAll(); } });
el.addEventListener('keydown', function (e) {
var k = e.key, s = 0.02;
if (k === 'ArrowLeft') p.x = Math.max(0, p.x - s); else if (k === 'ArrowRight') p.x = Math.min(1, p.x + s);
else if (k === 'ArrowUp') p.y = Math.max(0.03, p.y - s); else if (k === 'ArrowDown') p.y = Math.min(1, p.y + s);
else if (k === '+' || k === '=') act('bigger'); else if (k === '-') act('smaller');
else if (k === 'Delete' || k === 'Backspace') act('remove'); else return;
e.preventDefault(); render(p); save();
});
}
function act(a) {
if (a === 'clear') { if (!placed.length) return; placed.forEach(function (p) { p.el.remove(); }); placed = []; sel = null; say('All cleared. Time for a fresh design!'); save(); renderAll(); return; }
if (!sel) return; var p = sel, i = placed.indexOf(p);
if (a === 'bigger') p.w = Math.min(0.95, p.w * 1.12);
if (a === 'smaller') p.w = Math.max(0.06, p.w / 1.12);
if (a === 'flip') p.flip = !p.flip;
if (a === 'front' && i < placed.length - 1) { placed.splice(i, 1); placed.push(p); }
if (a === 'back' && i > 0) { placed.splice(i, 1); placed.unshift(p); }
if (a === 'remove') { p.el.remove(); placed.splice(i, 1); sel = null; say(p.item.name + ' removed.'); }
save(); renderAll(); if (sel && a !== 'remove') sel.el.focus({ preventScroll: true });
}
tools.forEach(function (b) { b.addEventListener('click', function () { act(b.dataset.sduTool); }); });
stage.addEventListener('pointerdown', function (e) { if (e.target === stage || e.target === layer || e.target === canvas) { sel = null; renderAll(); } });

// Tray + filters
var tray = root.querySelector('[data-sdu-tray]'), chips = root.querySelectorAll('[data-sdu-kind]');
items.forEach(function (it) {
var b = document.createElement('button'); b.type = 'button'; b.className = 'sdu-add'; b.dataset.kind = it.kind;
b.innerHTML = '<span><img loading="lazy" alt=""></span><b></b>'; b.querySelector('img').src = it.thumb; b.querySelector('b').textContent = it.name;
b.setAttribute('aria-label', 'Add ' + it.name);
b.addEventListener('click', function () {
var r = Math.random(), k = it.kind, x = 0.2 + r * 0.6, y = 0.5;
if (k === 'hide') y = 0.78 + Math.random() * 0.05;
else if (k === 'ledge') { y = 0.22 + Math.random() * 0.3; x = r < 0.5 ? 0.3 : 0.7; }
else if (k === 'wall') { y = 0.56; x = 0.3 + r * 0.4; }
else y = 0.3 + Math.random() * 0.2;
var p = add(it, x, y);
if (k === 'wall') { placed.splice(placed.indexOf(p), 1); placed.unshift(p); save(); renderAll(); }
});
tray.appendChild(b);
});
chips.forEach(function (c) {
var k = c.dataset.sduKind; if (k !== 'all' && !items.some(function (i) { return i.kind === k; })) { c.hidden = true; return; }
c.addEventListener('click', function () { chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c); }); tray.querySelectorAll('.sdu-add').forEach(function (b) { b.hidden = k !== 'all' && b.dataset.kind !== k; }); });
});

// Scenes
var sceneBtns = root.querySelectorAll('[data-sdu-scene]');
sceneBtns.forEach(function (b) {
var s = SCENES[b.dataset.sduScene], th = cfg.thumbs && cfg.thumbs[b.dataset.sduScene]; b.querySelector('i').style.background = th ? 'center / cover no-repeat url("' + th + '")' : s.swatch;
b.addEventListener('click', function () { scene = b.dataset.sduScene; sceneBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); drawBg(); save(); });
});
function markScene() { sceneBtns.forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.sduScene === scene); }); }

// Spood
var spood = stage.querySelector('[data-sdu-spood]'), sp = { x: 0.3, y: 0.87 };
function placeSpood() { spood.style.left = sp.x * 100 + '%'; spood.style.top = sp.y * 100 + '%'; }
function hop() {
if (document.hidden || !spood) return;
var spots = [{ x: 0.15 + Math.random() * 0.7, y: 0.87 + Math.random() * 0.05 }];
placed.forEach(function (p) { var hf = p.w * p.ar / ratio; spots.push({ x: p.x + (Math.random() - 0.5) * p.w * 0.5, y: p.y - hf / 2 + 0.01 }); spots.push({ x: p.x + (Math.random() - 0.5) * p.w * 0.5, y: p.y - hf / 2 + 0.01 }); });
var t = spots[Math.floor(Math.random() * spots.length)]; t.y = Math.max(0.12, Math.min(0.95, t.y)); t.x = Math.max(0.06, Math.min(0.94, t.x));
spood.classList.toggle('is-left', t.x < sp.x); sp = t; placeSpood();
if (!reduce) { spood.classList.remove('is-hop'); void spood.offsetWidth; spood.classList.add('is-hop'); }
}
if (spood) { if (cfg.spood) { spood.innerHTML = '<img alt="" src="' + cfg.spood + '">'; loadImg(cfg.spood, function (im) { spImg = im; }); } else spood.innerHTML = SPOOD; placeSpood(); if (!reduce) setInterval(hop, 3800); }

// Shop list
var shop = root.querySelector('[data-sdu-shop]');
function money(c) { try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(c / 100); } catch (e) { return '$' + (c / 100).toFixed(2); } }
function updateShop() {
if (!shop) return; var seen = {}, list = [];
placed.forEach(function (p) { var pr = p.item.product; if (pr && !seen[pr.url]) { seen[pr.url] = 1; list.push(pr); } });
var ul = shop.querySelector('ul'); ul.innerHTML = '';
var total = 0;
list.forEach(function (pr) { total += pr.cents || 0; var li = document.createElement('li'); li.innerHTML = '<img alt="" loading="lazy"><a></a><span></span>'; var im = li.querySelector('img'); if (pr.image) im.src = pr.image; else im.remove(); var a = li.querySelector('a'); a.href = pr.url; a.textContent = pr.title; li.querySelector('span').textContent = money(pr.cents || 0); ul.appendChild(li); });
shop.querySelector('[data-sdu-total]').textContent = money(total);
shop.querySelector('[data-sdu-count]').textContent = list.length;
var btn = root.querySelector('[data-sdu-shopbtn]'); if (btn) btn.disabled = !list.length;
if (!list.length) shop.hidden = true;
}
var shopBtn = root.querySelector('[data-sdu-shopbtn]');
if (shopBtn) shopBtn.addEventListener('click', function () { shop.hidden = !shop.hidden; if (!shop.hidden) shop.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' }); });

// Save picture
var saveBtn = root.querySelector('[data-sdu-save]');
if (saveBtn) saveBtn.addEventListener('click', function () {
say('Making your picture...');
Promise.all(placed.map(function (p) { return new Promise(function (res) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = p.item.img; }); })).then(function (imgs) { paint(imgs); });
});
function paint(imgs) {
var W = 1200, H = Math.round(1200 * ratio), c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d');
drawScene(x, W, H);
placed.forEach(function (p, i) {
var im = imgs[i]; if (!im) return;
var w = p.w * W, h = w * (im.naturalHeight / im.naturalWidth); x.save(); x.translate(p.x * W, p.y * H); if (p.flip) x.scale(-1, 1);
x.shadowColor = 'rgba(40,25,70,.28)'; x.shadowBlur = 12; x.shadowOffsetY = 8; x.drawImage(im, -w / 2, -h / 2, w, h); x.restore();
});
if (!photos[scene]) { x.fillStyle = 'rgba(255,255,255,.95)'; x.fillRect(0, 0, W, H * 0.05); }
var done = function () {
x.fillStyle = 'rgba(255,255,255,.9)'; x.beginPath(); x.roundRect ? x.roundRect(W - 470, H - 86, 440, 58, 29) : x.rect(W - 470, H - 86, 440, 58); x.fill();
x.fillStyle = '#7E5DB8'; x.font = '800 30px sans-serif'; x.textAlign = 'center'; x.fillText('Designed at Spood Society', W - 250, H - 46);
try {
c.toBlob(function (blob) {
if (!blob) { say('Sorry, saving did not work. Try a screenshot instead!'); return; }
var file = new File([blob], 'my-spood-enclosure.png', { type: 'image/png' });
if (navigator.canShare && navigator.canShare({ files: [file] })) { navigator.share({ files: [file], title: 'My spood enclosure' }).catch(function () {}); return; }
var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'my-spood-enclosure.png'; document.body.appendChild(a); a.click(); a.remove(); say('Saved! Check your downloads.');
});
} catch (e) { say('Sorry, saving did not work. Try a screenshot instead!'); }
};
if (spood && spImg) { var w2 = W * 0.13, h2 = w2 * spImg.naturalHeight / spImg.naturalWidth; x.save(); x.translate(sp.x * W, sp.y * H - h2 / 2); if (spood.classList.contains('is-left')) x.scale(-1, 1); x.drawImage(spImg, -w2 / 2, -h2 / 2, w2, h2); x.restore(); done(); } else if (spood) { var si = new Image(); si.onload = function () { var w = W * 0.12, h = w * 0.84; x.save(); x.translate(sp.x * W, sp.y * H - h / 2); if (spood.classList.contains('is-left')) x.scale(-1, 1); x.drawImage(si, -w / 2, -h / 2, w, h); x.restore(); done(); }; si.onerror = done; si.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(SPOOD.replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" ')); } else done();
}

// Restore
try { var saved = JSON.parse(localStorage.getItem(KEY) || 'null'); if (saved) { if (SCENES[saved.scene]) scene = saved.scene; (saved.p || []).forEach(function (a) { if (byId[a[0]]) add(byId[a[0]], a[1], a[2], a[3], a[4], true); }); } } catch (e) {}
sel = null; markScene(); drawBg(); renderAll();
var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(drawBg, 150); });
}
function all() { document.querySelectorAll('.sdu').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
document.addEventListener('shopify:section:load', all);
})();